import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';

import { LocalStorage } from './services/index.js';
import 'bootstrap/dist/js/bootstrap.js';
import './utils/all.js';
import './utils/theme.js';
// import './assets/styles/theme.min.css';
// import './assets/styles/theme-rtl.min.css';
import './index.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';
import {I18nextProvider} from "react-i18next";
import i18n from './utils/i18n';

// const themeStylesFile = (LocalStorage.get('language') && LocalStorage.get('language') === 'fa') ? './assets/styles/theme-rtl.min.css' : './assets/styles/theme.min.css';
// import(themeStylesFile);

const root = createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </I18nextProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
